import { extend, override } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import YandexSmartCaptcha from './components/YandexSmartCaptcha';
export default function extendAuthModalsWithYandexSmartCaptcha() {
  const isEnabled = type => !!app.forum.attribute(`forumaker-yandex-smart-captcha.${type}`);
  const getSiteKey = () => app.forum.attribute('forumaker-yandex-smart-captcha.site_key');
  const applyExtenders = (modulePath, type, dataMethod) => {
    extend(modulePath, 'oninit', function () {
      if (!isEnabled(type)) return;
      const siteKey = getSiteKey();
      if (!siteKey) return;
      this.yandexSmartCaptcha = {
        token: null,
        widgetId: null,
        siteKey
      };
    });
    extend(modulePath, dataMethod, function (data) {
      if (!isEnabled(type) || !this.yandexSmartCaptcha) return;
      data['smart-token'] = this.yandexSmartCaptcha.token || '';
    });
    extend(modulePath, 'fields', function (items) {
      if (!isEnabled(type) || !this.yandexSmartCaptcha?.siteKey) return;
      items.add('yandex-smart-captcha', m(YandexSmartCaptcha, {
        state: this.yandexSmartCaptcha
      }), -5);
    });
    override(modulePath, 'onsubmit', function (original, e) {
      if (!isEnabled(type) || !this.yandexSmartCaptcha) {
        return original(e);
      }
      if (!this.yandexSmartCaptcha.token) {
        e.preventDefault();
        this.loading = false;
        this.alertAttrs = {
          type: 'error',
          content: app.translator.trans('forumaker-yandex-smart-captcha.forum.validation.captcha_required')
        };
        m.redraw();
        return;
      }
      return original(e);
    });
    extend(modulePath, 'onerror', function (_, error) {
      if (!isEnabled(type) || !this.yandexSmartCaptcha) return;
      if (this.yandexSmartCaptcha.widgetId !== null && window.smartCaptcha) {
        window.smartCaptcha.reset(this.yandexSmartCaptcha.widgetId);
      }
      this.yandexSmartCaptcha.token = null;
      if (error.alert && !error.alert.content?.length) {
        error.alert.content = app.translator.trans('forumaker-yandex-smart-captcha.forum.validation.captcha_invalid');
      }
    });
  };
  applyExtenders('flarum/forum/components/LogInModal', 'signin', 'loginParams');
  applyExtenders('flarum/forum/components/SignUpModal', 'signup', 'submitData');
}